export default "__VITE_ASSET__Bc3aucX6__"